import { z } from 'zod';
import { dateSchema } from '../../validation';
import { termDurationSchema } from '../../common';

export const invoicePeriodSchema = z.object({
  /** the full duration of the period such as 60 days / 1 month / immediately.
   *
   * This is the duration of the invoice from the start date (`from`) to the pay date (`due`).
   */
  duration: termDurationSchema,
  /** the from date (Invoice Starting Date) */
  from: dateSchema,
  /** the to date (Invoice Closing Date) */
  to: dateSchema,
  /** the due date (Invoice Pay Date) */
  /** when this invoice must be paid.
   * this will be based on the `Payer` payment terms {@link AgreementTerms} which is
   * coming from the `Agreement` Collection.
   */
  due: dateSchema,
  /** the actual issuance date of the invoice ... by default it's the same as the `to` date because we will issue the invoice at the end of the period.
   *
   * but this could change in the future when we will issue the actual invoice because it might differ from the due to manual issues with the customer/carrier.
   */
  issuance: dateSchema,
});
